import React, { ReactElement, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { useSelector, TypedUseSelectorHook, useDispatch } from "react-redux";

import { remove } from "redux/errors/errorsSlice";
import { RootState } from "redux/rootReducer";

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

export default function ErrorToast(): ReactElement {
  const dispatch = useDispatch();

  const errors = useTypedSelector((state) => state.errors);
  useEffect(() => {
    // This runs whenever the error list changes, so it sees errors that are
    // already on screen too. Keying each toast by the error's id makes
    // react-toastify show it only once.
    errors.forEach((item) => {
      const toastId = item.id as string;
      if (toast.isActive(toastId)) return;
      toast.error(item.message, {
        toastId,
        onClose: () => dispatch(remove(toastId)),
      });
    });
  }, [errors, dispatch]);
  return (
    <div data-testid="error-toast">
      <ToastContainer />
    </div>
  );
}
